import React, { Fragment, useMemo, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MDBContainer, MDBCard, MDBCardBody, MDBCardHeader, MDBInput, MDBBtn, MDBRow, MDBCol, MDBTextArea, MDBTabs, MDBTabsItem, MDBTabsLink, MDBTabsContent, MDBRadio } from  'mdb-react-ui-kit';
import agent from '../../../agent';
import { SETTINGS, SAVE_SETTINGS, CLEAR_FLASH_MESSAGE, LOADER_SHOW } from '../../../constants/actionTypes';
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2'; // For the confirmation dialog
import "./settings.scss";
const mapStateToProps = (state) => ({
  ...state,
  settingSaveSuccess: state.auth.settingSaveSuccess,
  settingSaveError: state.auth.settingSaveError,
});

const mapDispatchToProps = (dispatch) => ({
  submitForm: (values) => {
      dispatch({ type: SAVE_SETTINGS, payload: agent.Auth.saveSettings(values) });
  },
  getSettings: async (setSettingData, setErrorMsg, callLoaderShow) => {
      callLoaderShow(true);
      try {
        const getSettingsData = await agent.Auth.getSettings();
        callLoaderShow(false);
        if(getSettingsData && getSettingsData.data && getSettingsData.data.settings){
          setSettingData(getSettingsData.data.settings);
        }else{
          setSettingData(null);
        }
      } catch (error) {
         callLoaderShow(false);
         setErrorMsg(error.message);
         setSettingData(null);
      }
      //dispatch({ type: SETTINGS, payload: agent.Auth.getSettings(values) });
  },
  clearFlash: () => {
    dispatch({ type: CLEAR_FLASH_MESSAGE });
  },
  callLoaderShow: (type) => {
    dispatch({ type: LOADER_SHOW, payload: { type } });
  },
});

const Settings = (props) => {
  const { getSettings, clearFlash, submitForm, settingSaveSuccess,settingSaveError, callLoaderShow} = props;
  const [errorMsg, setErrorMsg] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  const [xeroErrorMsg, setXeroErrorMsg] = useState(null);
  const [xeroSuccessMsg, setXeroSuccessMsg] = useState(null);
  const [SettingData, setSettingData] = useState(null);

  // Top-level Settings tabs (client request: organize Settings in tabs)
  const [activeMainTab, setActiveMainTab] = useState('ringcentral');
  const handleMainTabClick = (tab) => (e) => {
    e.preventDefault();
    if (activeMainTab !== tab) setActiveMainTab(tab);
  };
  
  const [QuickErrorMsg, setQuickErrorMsg] = useState(null);
  const [QuickSuccessMsg, setQuickSuccessMsg] = useState(null);
  
  const [emailRecipientsMsg, setEmailRecipientsMsg] = useState(null);
  const [emailRecipientsErr, setEmailRecipientsErr] = useState(null);

  const [formData, setFormData] = useState({
    client_id: '',
    secret_id: '',
    ringcentral_url: '',
    jwt_token: '',
    days_count: ''
  });
  
    const [emailRecipientsFormData, setEmailRecipientsFormData] = useState({
        
        approval_send_to: '',        
        approval_cc: '',            
        client_bcc: '',
        approval_subject_template: '',
        client_subject_template: '',
    });

  const [xeroFormData, setXeroFormData] = useState({
    xero_client_id: '',
    xero_client_secret: '',
    xero_redirect_uri: ''
  });
  
  const [quickFormData, setquickFormData] = useState({
    quick_client_id: '',
    quick_client_secret: '',
    quick_redirect_uri: '',
    quick_environment: 'production'
  });

  //Setting Options State
  const [activeSettingTab, setActiveSettingTab] = useState('xerosetting');
  // for xero & quick books tabs
  const handleSettingTabClick = (tab) => (e) => {
    e.preventDefault();
    if (activeSettingTab !== tab) setActiveSettingTab(tab);
  };
  const [selectedOption, setSelectedOption] = useState("xero");
  const handleSettingChange = (value) => {
    setSelectedOption(value);
  };
  //SHOW TABS = SELECT OPTIONS
  useEffect(() => {
    if (selectedOption === "xero") {
      setActiveSettingTab("xerosetting");
    } else if (selectedOption === "quickbooks") {
      setActiveSettingTab("quickbooks");
    } else if (selectedOption === "both") {
      setActiveSettingTab("xerosetting"); // default
    } else {
      setActiveSettingTab("xerosetting"); // default
    }
  }, [selectedOption]);


  // SMTP state
  const [activeSmtpTab, setActiveSmtpTab] = useState('general');
  const [smtpFormData, setSmtpFormData] = useState({
    smtp_host: '',
    smtp_port: '',
    smtp_secure: '', // none | ssl | tls
    smtp_from_email: '',
    smtp_username: '',
    smtp_password: ''
  });
  const [smtpGeneralMsg, setSmtpGeneralMsg] = useState(null);
  const [smtpGeneralErr, setSmtpGeneralErr] = useState(null);

  const [smtpEstimatesFormData, setSmtpEstimatesFormData] = useState({
    estimates_smtp_host: '',
    estimates_smtp_port: '',
    estimates_smtp_secure: '', // none | ssl | tls
    estimates_smtp_from_email: '',
    estimates_smtp_username: '',
    estimates_smtp_password: ''
  });
  const [smtpEstimatesMsg, setSmtpEstimatesMsg] = useState(null);
  const [smtpEstimatesErr, setSmtpEstimatesErr] = useState(null);

  const handleSmtpTabClick = (tab) => (e) => {
    e.preventDefault();
    if (activeSmtpTab !== tab) setActiveSmtpTab(tab);
  };

  // GA/GSC settings
  const [googleFormData, setGoogleFormData] = useState({
    google_oauth_client_id: '',
    google_oauth_client_secret: '',
    google_oauth_redirect_uri: ''
  });
  const [googleWebsites, setGoogleWebsites] = useState([]);
  const [googleMsg, setGoogleMsg] = useState(null);
  const [googleErr, setGoogleErr] = useState(null);

  const canConnectGoogle = useMemo(() => {
    return (
      googleFormData.google_oauth_client_id &&
      googleFormData.google_oauth_client_secret &&
      googleFormData.google_oauth_redirect_uri
    );
  }, [googleFormData]);

  const handleSubmit = (e) => {
    clearFlash();

    e.preventDefault();

    const formDataNew = new FormData();
    formDataNew.append("settings[client_id]", formData.client_id);
    formDataNew.append("settings[secret_id]", formData.secret_id);
    formDataNew.append("settings[ringcentral_url]", formData.ringcentral_url);
    formDataNew.append("settings[jwt_token]", formData.jwt_token);
    formDataNew.append("settings[days_count]", formData.days_count);
       
    submitForm(formDataNew);

  }
  const handleSmtpChange = (e) => {
    const { name, value } = e.target;
    setSmtpFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSmtpEstimatesChange = (e) => {
    const { name, value } = e.target;
    setSmtpEstimatesFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSmtpSubmit = (e) => {
    e.preventDefault();
    clearFlash();
    setSmtpGeneralErr(null);
    setSmtpGeneralMsg(null);

    const formDataNew = new FormData();
    formDataNew.append('settings[smtp_host]', smtpFormData.smtp_host);
    formDataNew.append('settings[smtp_port]', smtpFormData.smtp_port);
    formDataNew.append('settings[smtp_secure]', smtpFormData.smtp_secure);
    formDataNew.append('settings[smtp_from_email]', smtpFormData.smtp_from_email);
    formDataNew.append('settings[smtp_username]', smtpFormData.smtp_username);
    formDataNew.append('settings[smtp_password]', smtpFormData.smtp_password);

    submitForm(formDataNew);
    setSmtpGeneralMsg('SMTP (General) Settings Saved Successfully!');
  };

  const handleSmtpEstimatesSubmit = (e) => {
    e.preventDefault();
    clearFlash();
    setSmtpEstimatesErr(null);
    setSmtpEstimatesMsg(null);

    const formDataNew = new FormData();
    formDataNew.append('settings[estimates_smtp_host]', smtpEstimatesFormData.estimates_smtp_host);
    formDataNew.append('settings[estimates_smtp_port]', smtpEstimatesFormData.estimates_smtp_port);
    formDataNew.append('settings[estimates_smtp_secure]', smtpEstimatesFormData.estimates_smtp_secure);
    formDataNew.append('settings[estimates_smtp_from_email]', smtpEstimatesFormData.estimates_smtp_from_email);
    formDataNew.append('settings[estimates_smtp_username]', smtpEstimatesFormData.estimates_smtp_username);
    formDataNew.append('settings[estimates_smtp_password]', smtpEstimatesFormData.estimates_smtp_password);

    submitForm(formDataNew);
    setSmtpEstimatesMsg('SMTP (Estimates) Settings Saved Successfully!');
  };

  const handleXeroSubmit = (e) => {
    clearFlash();
    setXeroErrorMsg(null);
    setXeroSuccessMsg(null);

    e.preventDefault();

    const formDataNew = new FormData();
    formDataNew.append("settings[xero_client_id]", xeroFormData.xero_client_id);
    formDataNew.append("settings[xero_client_secret]", xeroFormData.xero_client_secret);
    formDataNew.append("settings[xero_redirect_uri]", xeroFormData.xero_redirect_uri);
    
    formDataNew.append("settings[accounting_platform]", selectedOption);
     
    submitForm(formDataNew);

    // Show success message for Xero settings
    setXeroSuccessMsg("Xero Settings Saved Successfully!");

  }
  
   
  const handleQuickSubmit = (e) => {
    clearFlash();
    setQuickErrorMsg(null);
    setQuickSuccessMsg(null);

    e.preventDefault();

    const formDataNew = new FormData();
    formDataNew.append("settings[quick_client_id]", quickFormData.quick_client_id);
    formDataNew.append("settings[quick_client_secret]", quickFormData.quick_client_secret);
    formDataNew.append("settings[quick_redirect_uri]", quickFormData.quick_redirect_uri);
    
    formDataNew.append("settings[quick_environment]", quickFormData.quick_environment);

    
    formDataNew.append("settings[accounting_platform]", selectedOption);
       
    submitForm(formDataNew);

    // Show success message for Xero settings
    setQuickSuccessMsg("QuicBooks Settings Saved Successfully!");

  }
  
   const handleEmailRecipientsChange = (e) => {
      const { name, value } = e.target;
      setEmailRecipientsFormData(prev => ({ ...prev, [name]: value }));
    };
    
    const handleEmailRecipientsSubmit = (e) => {
      e.preventDefault();
      clearFlash();
      setEmailRecipientsErr(null);
      setEmailRecipientsMsg(null);
    
      const formDataNew = new FormData();
      formDataNew.append('settings[approval_send_to]', emailRecipientsFormData.approval_send_to);
      formDataNew.append('settings[approval_cc]',      emailRecipientsFormData.approval_cc);
      formDataNew.append('settings[client_bcc]',       emailRecipientsFormData.client_bcc);
      formDataNew.append('settings[approval_subject_template]', emailRecipientsFormData.approval_subject_template);
      formDataNew.append('settings[client_subject_template]',   emailRecipientsFormData.client_subject_template);
    
      submitForm(formDataNew);
      setEmailRecipientsMsg('Email recipient settings saved successfully!');
    };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleXeroChange = (e) => {
    const { name, value } = e.target;
    setXeroFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  
  const handlequickChange = (e) => {
    const { name, value } = e.target;
    setquickFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleGoogleChange = (e) => {
    const { name, value } = e.target;
    setGoogleFormData((prev) => ({ ...prev, [name]: value }));
  };

  const addGoogleWebsite = () => {
    setGoogleWebsites((prev) => [
      ...prev,
      {
        key: `site_${Date.now()}_${Math.floor(Math.random() * 100000)}`,
        name: '',
        ga4PropertyId: '',
        gscSiteUrl: ''
      }
    ]);
  };

  const updateGoogleWebsite = (idx, patch) => {
    setGoogleWebsites((prev) =>
      prev.map((w, i) => (i === idx ? { ...w, ...patch } : w))
    );
  };

  const removeGoogleWebsite = async (idx) => {
    const ok = await Swal.fire({
      title: 'Remove website?',
      text: 'This will remove it from settings. (It will not delete anything in Google.)',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Remove',
    });
    if (!ok.isConfirmed) return;
    setGoogleWebsites((prev) => prev.filter((_, i) => i !== idx));
  };

  const saveGoogleSettings = (e) => {
    e.preventDefault();
    clearFlash();
    setGoogleErr(null);
    setGoogleMsg(null);

    const cleanedWebsites = (googleWebsites || [])
      .filter((w) => w && (w.name || w.ga4PropertyId || w.gscSiteUrl))
      .map((w) => ({
        key: w.key,
        name: w.name || '',
        ga4PropertyId: w.ga4PropertyId ? String(w.ga4PropertyId).trim() : '',
        gscSiteUrl: w.gscSiteUrl ? String(w.gscSiteUrl).trim() : ''
      }));

    const formDataNew = new FormData();
    formDataNew.append('settings[google_oauth_client_id]', googleFormData.google_oauth_client_id);
    formDataNew.append('settings[google_oauth_client_secret]', googleFormData.google_oauth_client_secret);
    formDataNew.append('settings[google_oauth_redirect_uri]', googleFormData.google_oauth_redirect_uri);
    formDataNew.append('settings[google_websites]', JSON.stringify(cleanedWebsites));

    submitForm(formDataNew);
    setGoogleMsg('Google settings saved. You can now connect websites.');
  };

  const connectGoogleWebsite = async (websiteKey) => {
  try {
    setGoogleErr(null);
    setGoogleMsg(null);

    if (!googleFormData.google_oauth_client_id ||
        !googleFormData.google_oauth_client_secret ||
        !googleFormData.google_oauth_redirect_uri) {
      setGoogleErr('Please fill in Google OAuth settings first.');
      return;
    }

    // Auto-save silently before connecting
    const cleanedWebsites = (googleWebsites || [])
      .filter((w) => w && (w.name || w.ga4PropertyId || w.gscSiteUrl))
      .map((w) => ({
        key: w.key,
        name: w.name || '',
        ga4PropertyId: w.ga4PropertyId ? String(w.ga4PropertyId).trim() : '',
        gscSiteUrl: w.gscSiteUrl ? String(w.gscSiteUrl).trim() : ''
      }));

    const autoSave = new FormData();
    autoSave.append('settings[google_oauth_client_id]', googleFormData.google_oauth_client_id);
    autoSave.append('settings[google_oauth_client_secret]', googleFormData.google_oauth_client_secret);
    autoSave.append('settings[google_oauth_redirect_uri]', googleFormData.google_oauth_redirect_uri);
    autoSave.append('settings[google_websites]', JSON.stringify(cleanedWebsites));
    submitForm(autoSave);

    callLoaderShow(true);
    const r = await agent.Google.getOAuthUrl(websiteKey);
    callLoaderShow(false);

    if (r && r.data && r.data.url) {
      const popup = window.open(r.data.url, '_blank', 'noopener,noreferrer,width=600,height=700');

      const handleMessage = (event) => {
        if (event.data?.type === 'GOOGLE_OAUTH_SUCCESS') {
          window.removeEventListener('message', handleMessage);
          setGoogleMsg('Google connected successfully!');
          getSettings(setSettingData, setErrorMsg, callLoaderShow);
        }
      };
      window.addEventListener('message', handleMessage);

      // Fallback: poll in case postMessage doesn't fire
      const timer = setInterval(() => {
        if (popup && popup.closed) {
          clearInterval(timer);
          window.removeEventListener('message', handleMessage);
          getSettings(setSettingData, setErrorMsg, callLoaderShow);
        }
      }, 1000);

      return;
    }

    setGoogleErr('Failed to generate OAuth URL.');
  } catch (err) {
    callLoaderShow(false);
    setGoogleErr(err?.message || 'Google connect failed');
  }
};

  useEffect(() => {
    getSettings(setSettingData, setErrorMsg, callLoaderShow);
  }, []);

  useEffect(() => {
    if (settingSaveError) {
      setErrorMsg(settingSaveError);
      clearFlash();
    }
  }, [settingSaveError]);

  useEffect(() => {
    if (settingSaveSuccess) {
      setSuccessMsg(settingSaveSuccess);
      clearFlash();
    }
  }, [settingSaveSuccess]);

  // For now, we'll simulate Xero success message
  // You can replace this with actual API response handling
  useEffect(() => {
    if (settingSaveSuccess && settingSaveSuccess.includes('xero')) {
      setXeroSuccessMsg("Xero Settings Saved Successfully!");
      clearFlash();
    }
  }, [settingSaveSuccess]);

  useEffect(() => {
    if(SettingData){
        setFormData({
          client_id: (SettingData.client_id)?SettingData.client_id:'',
          secret_id: (SettingData.secret_id)?SettingData.secret_id:'',
          ringcentral_url: (SettingData.ringcentral_url)?SettingData.ringcentral_url:'',
          jwt_token: (SettingData.jwt_token)?SettingData.jwt_token:'',
          days_count: (SettingData.days_count)?SettingData.days_count:'',
        });
      
        setEmailRecipientsFormData({
          approval_send_to: SettingData.approval_send_to || '',
          approval_cc:      SettingData.approval_cc      || '',
          client_bcc:       SettingData.client_bcc       || '',
          approval_subject_template: SettingData.approval_subject_template || '',
          client_subject_template:   SettingData.client_subject_template   || '',
        });

      setXeroFormData({
        xero_client_id: (SettingData.xero_client_id)?SettingData.xero_client_id:'',
        xero_client_secret: (SettingData.xero_client_secret)?SettingData.xero_client_secret:'',
        xero_redirect_uri: (SettingData.xero_redirect_uri)?SettingData.xero_redirect_uri:'',
      });
      
      if (SettingData.accounting_platform) {
		  setSelectedOption(SettingData.accounting_platform);
	  }
      
      setquickFormData({
        quick_client_id: (SettingData.quick_client_id)?SettingData.quick_client_id:'',
        quick_client_secret: (SettingData.quick_client_secret)?SettingData.quick_client_secret:'',
        quick_redirect_uri: (SettingData.quick_redirect_uri)?SettingData.quick_redirect_uri:'',
        quick_environment: SettingData.quick_environment || 'production',
      });

      setSmtpFormData({
        smtp_host: (SettingData.smtp_host)?SettingData.smtp_host:'',
        smtp_port: (SettingData.smtp_port)?SettingData.smtp_port:'',
        smtp_secure: (SettingData.smtp_secure)?SettingData.smtp_secure:'',
        smtp_from_email: (SettingData.smtp_from_email)?SettingData.smtp_from_email:'',
        smtp_username: (SettingData.smtp_username)?SettingData.smtp_username:'',
        smtp_password: (SettingData.smtp_password)?SettingData.smtp_password:'',
      });

      setSmtpEstimatesFormData({
        estimates_smtp_host: (SettingData.estimates_smtp_host)?SettingData.estimates_smtp_host:'',
        estimates_smtp_port: (SettingData.estimates_smtp_port)?SettingData.estimates_smtp_port:'',
        estimates_smtp_secure: (SettingData.estimates_smtp_secure)?SettingData.estimates_smtp_secure:'',
        estimates_smtp_from_email: (SettingData.estimates_smtp_from_email)?SettingData.estimates_smtp_from_email:'',
        estimates_smtp_username: (SettingData.estimates_smtp_username)?SettingData.estimates_smtp_username:'',
        estimates_smtp_password: (SettingData.estimates_smtp_password)?SettingData.estimates_smtp_password:'',
      });

      setGoogleFormData({
        google_oauth_client_id: SettingData.google_oauth_client_id ? SettingData.google_oauth_client_id : '',
        google_oauth_client_secret: SettingData.google_oauth_client_secret ? SettingData.google_oauth_client_secret : '',
        google_oauth_redirect_uri: SettingData.google_oauth_redirect_uri ? SettingData.google_oauth_redirect_uri : '',
      });

      try {
        const raw = SettingData.google_websites ? String(SettingData.google_websites) : '[]';
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          setGoogleWebsites(
            parsed.map((w) => ({
              key: w.key || `site_${Date.now()}_${Math.floor(Math.random() * 100000)}`,
              name: w.name || '',
              ga4PropertyId: w.ga4PropertyId || '',
              gscSiteUrl: w.gscSiteUrl || ''
            }))
          );
        } else {
          setGoogleWebsites([]);
        }
      } catch {
        setGoogleWebsites([]);
      }
    }
  }, [SettingData]);

  return (
    <MDBContainer className="mt-5 create_user setting_wrap roles_maincard">
      <MDBCard className="mb-4">
        <MDBCardHeader>
          <h4>Settings</h4>
        </MDBCardHeader>
        <MDBCardBody>
          <MDBTabs className="mb-3">
            <MDBTabsItem>
              <MDBTabsLink onClick={handleMainTabClick('ringcentral')} active={activeMainTab === 'ringcentral'}>
                RingCentral
              </MDBTabsLink>
            </MDBTabsItem>
            
            <MDBTabsItem>
              <MDBTabsLink onClick={handleMainTabClick('xeroqb')} active={activeMainTab === 'xeroqb'}>
                Xero / QuickBooks
              </MDBTabsLink>
            </MDBTabsItem>
            
            <MDBTabsItem>
              <MDBTabsLink onClick={handleMainTabClick('smtp')} active={activeMainTab === 'smtp'}>
                SMTP
              </MDBTabsLink>
            </MDBTabsItem>
            
            <MDBTabsItem>
              <MDBTabsLink onClick={handleMainTabClick('emailrecipients')} active={activeMainTab === 'emailrecipients'}>
                Email Recipients
              </MDBTabsLink>
            </MDBTabsItem>
            
            <MDBTabsItem>
              <MDBTabsLink onClick={handleMainTabClick('google')} active ={activeMainTab === 'google'}>
                GA / GSC
              </MDBTabsLink>
            </MDBTabsItem>
          </MDBTabs>

          <MDBTabsContent>
            {/* RingCentral */}
            {activeMainTab === 'ringcentral' && (
              <div className="tab-pane show active">
                <MDBCard className="mt-2">
                  <MDBCardHeader>
                    <h4>RingCentral Settings</h4>
                  </MDBCardHeader>
                  <MDBCardBody>
                    <form onSubmit={handleSubmit}>
                      {errorMsg ? (
                        <div className="alert alert-danger" role="alert">{errorMsg}</div>
                      ) : <Fragment />}
                      {successMsg ? (
                        <div className="alert alert-success" role="alert">{successMsg}</div>
                      ) : <Fragment />}
                      <MDBRow className="g-4 mb-4" encType="multipart/form-data">
                        <MDBCol md="12">
                          <div className="form-group">
                            <label htmlFor="client_id">Client ID</label>
                            <MDBInput
                              name="client_id"
                              type="text"
                              value={formData.client_id}
                              onChange={handleChange}
                              required
                              className="form-control"
                            />
                          </div>
                        </MDBCol>
                        <MDBCol md="12">
                          <div className="form-group">
                            <label htmlFor="secret_id">Secret ID</label>
                            <MDBInput
                              name="secret_id"
                              type="text"
                              value={formData.secret_id}
                              onChange={handleChange}
                              required
                              className="form-control"
                            />
                          </div>
                        </MDBCol>
    
                        <MDBCol md="12">
                          <div className="form-group">
                            <label htmlFor="ringcentral_url">Ring Central Url</label>
                            <MDBInput
                              name="ringcentral_url"
                              type="text"
                              value={formData.ringcentral_url}
                              onChange={handleChange}
                              required
                              className="form-control"
                            />
                          </div>
                        </MDBCol>
    
                        <MDBCol md="12">
                          <div className="form-group">
                            <label htmlFor="jwt_token">JWT Token</label>
                            <MDBTextArea
                              name="jwt_token"
                              value={formData.jwt_token}
                              onChange={handleChange}
                              rows={4}
                              className="form-control"
                            />
                          </div>
                        </MDBCol>
    
                        <MDBCol md="12">
                          <div className="form-group">
                            <label htmlFor="days_count">Days</label>
                            <MDBInput
                              name="days_count"
                              type="number"
                              value={formData.days_count}
                              onChange={handleChange}
                              required
                              className="form-control"
                            />
                          </div>
                        </MDBCol>
                      </MDBRow>
                      <MDBCol md="12" className="d-flex gap-4">
                        <MDBBtn type="submit" color="primary" className="w-20">Save Ring Central Settings</MDBBtn>
                      </MDBCol>
                    </form>
                   </MDBCardBody>
                </MDBCard>
              </div>
            )}
      
            {/* Xero / QuickBooks */}
            {activeMainTab === 'xeroqb' && (
              <div className="tab-pane show active">
                <MDBCard className="mt-2">
                  <MDBCardHeader>
                    <h4 className="mb-0">Xero/Quickbooks Settings</h4>

                    <MDBRow className="g-4 mb-4 mt-2">
                      <MDBCol md="12">
                        <MDBRow className="g-3">
                          <MDBCol md="12">
                            <MDBCard className={`radiobtn p-0 ${ selectedOption === "xero" ? "active" : "" }`} onClick={() => handleSettingChange("xero")}>
                              <MDBCardBody className="text-left p-0">
                                <MDBRadio name="select_setting_option" id="xero" label="Xero Setting" value="xero" checked={selectedOption === "xero"} onChange={() => handleSettingChange("xero")} />
                              </MDBCardBody>
                            </MDBCard>

                            <MDBCard className={`radiobtn p-0 ${ selectedOption === "quickbooks" ? "active" : "" }`} onClick={() => handleSettingChange("quickbooks")}>
                              <MDBCardBody className="text-left p-0">
                                <MDBRadio name="select_setting_option" id="quickbooks" label="Quick Books" value="quickbooks" checked={selectedOption === "quickbooks"} onChange={() => handleSettingChange("quickbooks")} />
                              </MDBCardBody>
                            </MDBCard>

                            <MDBCard className={`radiobtn p-0 ${ selectedOption === "both" ? "active" : "" }`} onClick={() => handleSettingChange("both")} >
                              <MDBCardBody className="text-left p-0">
                                <MDBRadio name="select_setting_option" id="both" label="Xero + QuickBooks" value="both" checked={selectedOption === "both"} onChange={() => handleSettingChange("both")}/>
                              </MDBCardBody>
                            </MDBCard>
                          </MDBCol>
                        </MDBRow>
                      </MDBCol>
                    </MDBRow>
                  </MDBCardHeader>

                  <MDBCardBody>
                    <MDBTabs className="mb-3">
                      {(selectedOption === "xero" || selectedOption === "both") && (
                        <MDBTabsItem>
                          <MDBTabsLink onClick={handleSettingTabClick('xerosetting')} active={activeSettingTab === 'xerosetting'}>
                            Xero Settings
                          </MDBTabsLink>
                        </MDBTabsItem>
                      )}

                      {(selectedOption === "quickbooks" || selectedOption === "both") && (
                        <MDBTabsItem>
                          <MDBTabsLink onClick={handleSettingTabClick('quickbooks')} active={activeSettingTab === 'quickbooks'}>
                            Quick Books
                          </MDBTabsLink>
                        </MDBTabsItem>
                      )}
                    </MDBTabs>

                    <MDBTabsContent>
                      {(selectedOption === "xero" || selectedOption === "both") &&
                        activeSettingTab === 'xerosetting' && (
                        <div className="tab-pane show active">
                          <form onSubmit={handleXeroSubmit}>
                            {xeroErrorMsg ? (
                              <div className="alert alert-danger" role="alert">{xeroErrorMsg}</div>
                            ) : <Fragment />}
                            {xeroSuccessMsg ? (
                              <div className="alert alert-success" role="alert">{xeroSuccessMsg}</div>
                            ) : <Fragment />}
                            <MDBRow className="g-4 mb-4" encType="multipart/form-data">
                              <MDBCol md="12">
                                <div className="form-group">
                                  <label htmlFor="xero_client_id">Xero Client ID</label>
                                  <MDBInput
                                    name="xero_client_id"
                                    type="text"
                                    value={xeroFormData.xero_client_id}
                                    onChange={handleXeroChange}
                                    required
                                    className="form-control"
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol md="12">
                                <div className="form-group">
                                  <label htmlFor="xero_client_secret">Xero Client Secret</label>
                                  <MDBInput
                                    name="xero_client_secret"
                                    type="text"
                                    value={xeroFormData.xero_client_secret}
                                    onChange={handleXeroChange}
                                    required
                                    className="form-control"
                                  />
                                </div>
                              </MDBCol>

                              <MDBCol md="12">
                                <div className="form-group">
                                  <label htmlFor="xero_redirect_uri">Xero Redirect URI</label>
                                  <MDBInput
                                    name="xero_redirect_uri"
                                    type="text"
                                    value={xeroFormData.xero_redirect_uri}
                                    onChange={handleXeroChange}
                                    required
                                    className="form-control"
                                  />
                                </div>
                              </MDBCol>
                            </MDBRow>
                            <MDBCol md="12" className="d-flex gap-4">
                              <MDBBtn type="submit" color="primary" className="w-20">Save Xero Settings</MDBBtn>
                            </MDBCol>
                          </form>
                        </div>
                      )}

                      {(selectedOption === "quickbooks" || selectedOption === "both") &&
                        activeSettingTab === 'quickbooks' && (
                        <div className="tab-pane show active">
                          <form onSubmit={handleQuickSubmit}>
                {QuickErrorMsg ? 
                    <div className="alert alert-danger" role="alert">{QuickErrorMsg}</div>
                : <Fragment /> }
                {QuickSuccessMsg ? 
                  <div className="alert alert-success" role="alert">{QuickSuccessMsg}</div>
                : <Fragment /> }
                <MDBRow className="g-4 mb-4" encType="multipart/form-data">
                  <MDBCol md="12">
                    <div className="form-group">
                      <label htmlFor="quick_client_id">QuickBook Client ID</label>
                      <MDBInput
                        name="quick_client_id"
                        type="text"
                        value={quickFormData.quick_client_id}
                        onChange={handlequickChange}
                        required
                        className="form-control"
                      />
                    </div>
                  </MDBCol>
                  <MDBCol md="12">
                    <div className="form-group">
                      <label htmlFor="quick_client_secret">QuickBook Client Secret</label>
                      <MDBInput
                        name="quick_client_secret"
                        type="text"
                        value={quickFormData.quick_client_secret}
                        onChange={handlequickChange}
                        required
                        className="form-control"
                      />
                    </div>
                  </MDBCol>

                  <MDBCol md="12">
                    <div className="form-group">
                      <label htmlFor="quick_redirect_uri">Quick Redirect URI</label>
                      <MDBInput
                        name="quick_redirect_uri"
                        type="text"
                        value={quickFormData.quick_redirect_uri}
                        onChange={handlequickChange}
                        required
                        className="form-control"
                      />
                    </div>
                  </MDBCol>
                  
                  <MDBCol md="12">
                    <div className="form-group">
                      <label>Environment</label>
                      <div className="d-flex gap-3 mt-1">
                        <MDBCard
                          className={`radiobtn p-0 ${quickFormData.quick_environment === 'production' ? 'active' : ''}`}
                          onClick={() => setquickFormData(prev => ({ ...prev, quick_environment: 'production' }))}
                        >
                          <MDBCardBody className="text-left p-0">
                            <MDBRadio
                              name="quick_environment"
                              id="quick_production"
                              label="Production"
                              value="production"
                              checked={quickFormData.quick_environment === 'production'}
                              onChange={() => setquickFormData(prev => ({ ...prev, quick_environment: 'production' }))}
                            />
                          </MDBCardBody>
                        </MDBCard>
                        <MDBCard
                          className={`radiobtn p-0 ${quickFormData.quick_environment === 'sandbox' ? 'active' : ''}`}
                          onClick={() => setquickFormData(prev => ({ ...prev, quick_environment: 'sandbox' }))}
                        >
                          <MDBCardBody className="text-left p-0">
                            <MDBRadio
                              name="quick_environment"
                              id="quick_sandbox"
                              label="Sandbox"
                              value="sandbox"
                              checked={quickFormData.quick_environment === 'sandbox'}
                              onChange={() => setquickFormData(prev => ({ ...prev, quick_environment: 'sandbox' }))}
                            />
                          </MDBCardBody>
                        </MDBCard>
                      </div>
                    </div>
                  
                  </MDBCol>
                  
                  
                </MDBRow>
                <MDBCol md="12" className="d-flex gap-4">
                  <MDBBtn type="submit" color="primary" className="w-20">Save QBO Settings</MDBBtn>
                </MDBCol>
              </form>
                        </div>
                      )}
                    </MDBTabsContent>
                  </MDBCardBody>
                </MDBCard>
              </div>
            )}

            {/* SMTP */}
            {activeMainTab === 'smtp' && (
              <div className="tab-pane show active">
                <MDBCard className="mt-2">
                  <MDBCardHeader>
                    <h4>SMTP Settings</h4>
                  </MDBCardHeader>
                  <MDBCardBody>
                    <MDBTabs className="mb-3">
                      <MDBTabsItem>
                        <MDBTabsLink onClick={handleSmtpTabClick('general')} active={activeSmtpTab === 'general'}>
                          General SMTP Options
                        </MDBTabsLink>
                      </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink onClick={handleSmtpTabClick('estimates')} active={activeSmtpTab === 'estimates'}>
                          Estimates SMTP Options
                        </MDBTabsLink>
                      </MDBTabsItem>
                    </MDBTabs>

                    <MDBTabsContent>
                      {activeSmtpTab === 'general' && (
                        <div className="tab-pane show active">
                          <form onSubmit={handleSmtpSubmit}>
                            {smtpGeneralErr ? (
                              <div className="alert alert-danger" role="alert">{smtpGeneralErr}</div>
                            ) : <Fragment />}
                            {smtpGeneralMsg ? (
                              <div className="alert alert-success" role="alert">{smtpGeneralMsg}</div>
                            ) : <Fragment />}

                            <MDBRow className="g-4 mb-4" encType="multipart/form-data">
                              <MDBCol md="12">
                                <div className="form-group">
                                  <label htmlFor="smtp_host">SMTP Host</label>
                                  <MDBInput
                                    name="smtp_host"
                                    type="text"
                                    value={smtpFormData.smtp_host}
                                    onChange={handleSmtpChange}
                                    required
                                    className="form-control"
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol md="12">
                                <div className="form-group">
                                  <label htmlFor="smtp_port">SMTP Port</label>
                                  <MDBInput
                                    name="smtp_port"
                                    type="number"
                                    value={smtpFormData.smtp_port}
                                    onChange={handleSmtpChange}
                                    required
                                    className="form-control"
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol md="12">
                                <div className="form-group">
                                  <label htmlFor="smtp_secure">Security (none/ssl/tls)</label>
                                  <MDBInput
                                    name="smtp_secure"
                                    type="text"
                                    value={smtpFormData.smtp_secure}
                                    onChange={handleSmtpChange}
                                    className="form-control"
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol md="12">
                                <div className="form-group">
                                  <label htmlFor="smtp_from_email">From Email</label>
                                  <MDBInput
                                    name="smtp_from_email"
                                    type="email"
                                    value={smtpFormData.smtp_from_email}
                                    onChange={handleSmtpChange}
                                    required
                                    className="form-control"
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol md="12">
                                <div className="form-group">
                                  <label htmlFor="smtp_username">Email / Username</label>
                                  <MDBInput
                                    name="smtp_username"
                                    type="text"
                                    value={smtpFormData.smtp_username}
                                    onChange={handleSmtpChange}
                                    required
                                    className="form-control"
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol md="12">
                                <div className="form-group">
                                  <label htmlFor="smtp_password">Password</label>
                                  <MDBInput
                                    name="smtp_password"
                                    type="password"
                                    value={smtpFormData.smtp_password}
                                    onChange={handleSmtpChange}
                                    required
                                    className="form-control"
                                  />
                                </div>
                              </MDBCol>
                            </MDBRow>
                            <MDBCol md="12" className="d-flex gap-4">
                              <MDBBtn type="submit" color="primary" className="w-20">Save General SMTP</MDBBtn>
                            </MDBCol>
                          </form>
                        </div>
                      )}

                      {activeSmtpTab === 'estimates' && (
                        <div className="tab-pane show active">
                          <form onSubmit={handleSmtpEstimatesSubmit}>
                            {smtpEstimatesErr ? (
                              <div className="alert alert-danger" role="alert">{smtpEstimatesErr}</div>
                            ) : <Fragment />}
                            {smtpEstimatesMsg ? (
                              <div className="alert alert-success" role="alert">{smtpEstimatesMsg}</div>
                            ) : <Fragment />}

                            <MDBRow className="g-4 mb-4" encType="multipart/form-data">
                              <MDBCol md="12">
                                <div className="form-group">
                                  <label htmlFor="estimates_smtp_host">SMTP Host</label>
                                  <MDBInput
                                    name="estimates_smtp_host"
                                    type="text"
                                    value={smtpEstimatesFormData.estimates_smtp_host}
                                    onChange={handleSmtpEstimatesChange}
                                    required
                                    className="form-control"
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol md="12">
                                <div className="form-group">
                                  <label htmlFor="estimates_smtp_port">SMTP Port</label>
                                  <MDBInput
                                    name="estimates_smtp_port"
                                    type="number"
                                    value={smtpEstimatesFormData.estimates_smtp_port}
                                    onChange={handleSmtpEstimatesChange}
                                    required
                                    className="form-control"
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol md="12">
                                <div className="form-group">
                                  <label htmlFor="estimates_smtp_secure">Security (none/ssl/tls)</label>
                                  <MDBInput
                                    name="estimates_smtp_secure"
                                    type="text"
                                    value={smtpEstimatesFormData.estimates_smtp_secure}
                                    onChange={handleSmtpEstimatesChange}
                                    className="form-control"
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol md="12">
                                <div className="form-group">
                                  <label htmlFor="estimates_smtp_from_email">From Email</label>
                                  <MDBInput
                                    name="estimates_smtp_from_email"
                                    type="email"
                                    value={smtpEstimatesFormData.estimates_smtp_from_email}
                                    onChange={handleSmtpEstimatesChange}
                                    required
                                    className="form-control"
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol md="12">
                                <div className="form-group">
                                  <label htmlFor="estimates_smtp_username">Email / Username</label>
                                  <MDBInput
                                    name="estimates_smtp_username"
                                    type="text"
                                    value={smtpEstimatesFormData.estimates_smtp_username}
                                    onChange={handleSmtpEstimatesChange}
                                    required
                                    className="form-control"
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol md="12">
                                <div className="form-group">
                                  <label htmlFor="estimates_smtp_password">Password</label>
                                  <MDBInput
                                    name="estimates_smtp_password"
                                    type="password"
                                    value={smtpEstimatesFormData.estimates_smtp_password}
                                    onChange={handleSmtpEstimatesChange}
                                    required
                                    className="form-control"
                                  />
                                </div>
                              </MDBCol>
                            </MDBRow>
                            <MDBCol md="12" className="d-flex gap-4">
                              <MDBBtn type="submit" color="primary" className="w-20">Save Estimates SMTP</MDBBtn>
                            </MDBCol>
                          </form>
                        </div>
                      )}
                    </MDBTabsContent>
                  </MDBCardBody>
                </MDBCard>
              </div>
            )}
            
            
            
            {activeMainTab === 'emailrecipients' && (
              <div className="tab-pane show active">
                <MDBCard className="mt-2">
                  <MDBCardHeader>
                    <h4>Email Recipients</h4>
                  </MDBCardHeader>
                  <MDBCardBody>
                    <form onSubmit={handleEmailRecipientsSubmit}>
                      {emailRecipientsErr && <div className="alert alert-danger">{emailRecipientsErr}</div>}
                      {emailRecipientsMsg && <div className="alert alert-success">{emailRecipientsMsg}</div>}
            
                      {/* ── Send for Approval ── */}
                      <h5 className="mb-3 mt-2">Send for Approval Email</h5>
                      <MDBRow className="g-4 mb-4">
                        <MDBCol md="12">
                          <div className="form-group">
                            <label>Send To <span className="text-muted small">(single email — e.g. Crystal)</span></label>
                            <MDBInput
                              name="approval_send_to"
                              type="email"
                              value={emailRecipientsFormData.approval_send_to}
                              onChange={handleEmailRecipientsChange}
                              className="form-control"
                              placeholder="crystal@example.com"
                            />
                          </div>
                        </MDBCol>
                        <MDBCol md="12">
                          <div className="form-group">
                            <label>CC <span className="text-muted small">(comma-separated — Christine, Georgina, Jeljie, Monit)</span></label>
                            <MDBInput
                              name="approval_cc"
                              type="text"
                              value={emailRecipientsFormData.approval_cc}
                              onChange={handleEmailRecipientsChange}
                              className="form-control"
                              placeholder="christine@example.com, georgina@example.com"
                            />
                          </div>
                        </MDBCol>
                        
                        
                        <MDBCol md="12">
                          <div className="form-group">
                            <label>Approval Email Subject</label>
                            <MDBInput
                              name="approval_subject_template"
                              type="text"
                              value={emailRecipientsFormData.approval_subject_template}
                              onChange={handleEmailRecipientsChange}
                              className="form-control"
                              placeholder="Estimate from Zavza Seal LLC - {{customer_name}} - {{estimate_number}}"
                            />
                            <div className="text-muted small mt-1">
                              Available: {'{{customer_name}}'}, {'{{estimate_number}}'}, {'{{category}}'}
                            </div>
                          </div>
                        </MDBCol>
                       </MDBRow>
            
                      <hr />
            
                      {/* ── Send to Client ── */}
                      <h5 className="mb-3 mt-3">Send to Client Email</h5>
                      <MDBRow className="g-4 mb-4">
                        <MDBCol md="12">
                          <div className="form-group">
                            <label>BCC <span className="text-muted small">(comma-separated team members — hidden from client)</span></label>
                            <MDBInput
                              name="client_bcc"
                              type="text"
                              value={emailRecipientsFormData.client_bcc}
                              onChange={handleEmailRecipientsChange}
                              className="form-control"
                              placeholder="team1@example.com, team2@example.com"
                            />
                          </div>
                        </MDBCol>
                        
                        <MDBCol md="12">
                          <div className="form-group">
                            <label>Client Email Subject</label>
                            <MDBInput
                              name="client_subject_template"
                              type="text"
                              value={emailRecipientsFormData.client_subject_template}
                              onChange={handleEmailRecipientsChange}
                              className="form-control"
                              placeholder="Estimate from Zavza Seal LLC - {{customer_name}} - {{estimate_number}}"
                            />
                            <div className="text-muted small mt-1">
                              Available: {'{{customer_name}}'}, {'{{estimate_number}}'}, {'{{category}}'}
                            </div>
                          </div>
                        </MDBCol>
                      </MDBRow>
                      
                      <MDBCol md="12" className="d-flex gap-4">
                        <MDBBtn type="submit" color="primary">Save Email Recipients</MDBBtn>
                      </MDBCol>
                    </form>
                  </MDBCardBody>
                </MDBCard>
              </div>
            )}

            {/* GA / GSC */}
            {activeMainTab === 'google' && (
              <div className="tab-pane show active">
                <MDBCard className="mt-2">
                  <MDBCardHeader>
                    <h4 className="mb-0">Google Analytics (GA) / Search Console (GSC)</h4>
                  </MDBCardHeader>
                  <MDBCardBody>
                    {googleErr ? (
                      <div className="alert alert-danger" role="alert">{googleErr}</div>
                    ) : <Fragment />}
                    {googleMsg ? (
                      <div className="alert alert-success" role="alert">{googleMsg}</div>
                    ) : <Fragment />}

                    <form onSubmit={saveGoogleSettings}>
                      <MDBRow className="g-4 mb-4">
                        <MDBCol md="12">
                          <div className="form-group">
                            <label htmlFor="google_oauth_client_id">Google OAuth Client ID</label>
                            <MDBInput
                              name="google_oauth_client_id"
                              type="text"
                              value={googleFormData.google_oauth_client_id}
                              onChange={handleGoogleChange}
                              required
                              className="form-control"
                            />
                          </div>
                        </MDBCol>
                        <MDBCol md="12">
                          <div className="form-group">
                            <label htmlFor="google_oauth_client_secret">Google OAuth Client Secret</label>
                            <MDBInput
                              name="google_oauth_client_secret"
                              type="password"
                              value={googleFormData.google_oauth_client_secret}
                              onChange={handleGoogleChange}
                              required
                              className="form-control"
                            />
                          </div>
                        </MDBCol>
                        <MDBCol md="12">
                          <div className="form-group">
                            <label htmlFor="google_oauth_redirect_uri">Redirect URI</label>
                            <MDBInput
                              name="google_oauth_redirect_uri"
                              type="text"
                              value={googleFormData.google_oauth_redirect_uri}
                              onChange={handleGoogleChange}
                              required
                              className="form-control"
                            />
                            <div className="text-muted small mt-1">
                              Use: {process.env.REACT_APP_BACKEND}/google/oauth/callback
                            </div>
                          </div>
                        </MDBCol>
                      </MDBRow>

                      <MDBCol md="12" className="d-flex gap-3 mb-4">
                        <MDBBtn type="submit" color="primary">Save Google Settings</MDBBtn>
                        <MDBBtn type="button" color="secondary" onClick={addGoogleWebsite}>
                          Add Website
                        </MDBBtn>
                      </MDBCol>
                    </form>

                    {(googleWebsites && googleWebsites.length > 0) ? (
                      <div className="mt-3">
                        {googleWebsites.map((w, idx) => (
                          <MDBCard className="mb-3" key={w.key}>
                            <MDBCardBody>
                              <MDBRow className="g-3">
                                <MDBCol md="4">
                                  <div className="form-group">
                                    <label>Website Name</label>
                                    <MDBInput
                                      type="text"
                                      value={w.name}
                                      onChange={(e) => updateGoogleWebsite(idx, { name: e.target.value })}
                                      className="form-control"
                                    />
                                  </div>
                                </MDBCol>
                                <MDBCol md="4">
                                  <div className="form-group">
                                    <label>GA4 Property ID</label>
                                    <MDBInput
                                      type="text"
                                      value={w.ga4PropertyId}
                                      onChange={(e) => updateGoogleWebsite(idx, { ga4PropertyId: e.target.value })}
                                      className="form-control"
                                      placeholder="e.g. 123456789"
                                    />
                                  </div>
                                </MDBCol>
                                <MDBCol md="4">
                                  <div className="form-group">
                                    <label>GSC Site URL</label>
                                    <MDBInput
                                      type="text"
                                      value={w.gscSiteUrl}
                                      onChange={(e) => updateGoogleWebsite(idx, { gscSiteUrl: e.target.value })}
                                      className="form-control"
                                      placeholder="e.g. https://example.com/"
                                    />
                                  </div>
                                </MDBCol>
                              </MDBRow>

                              <div className="d-flex gap-3 mt-3">
                                <MDBBtn
                                  type="button"
                                  color="primary"
                                  disabled={!canConnectGoogle || !w.key}
                                  onClick={() => connectGoogleWebsite(w.key)}
                                >
                                  Connect Google
                                </MDBBtn>
                                <MDBBtn type="button" color="danger" onClick={() => removeGoogleWebsite(idx)}>
                                  Remove
                                </MDBBtn>
                              </div>
                              <div className="text-muted small mt-2">
                                Tip: Save Google Settings after editing websites so the Reports page can switch between them.
                              </div>
                            </MDBCardBody>
                          </MDBCard>
                        ))}
                      </div>
                    ) : (
                      <div className="text-muted">
                        No websites added yet. Click “Add Website”.
                      </div>
                    )}
                  </MDBCardBody>
                </MDBCard>
              </div>
            )}

          </MDBTabsContent>
        </MDBCardBody>
      </MDBCard>
      
    </MDBContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
